const ONE_DAY_MS = 60 * 60 * 24 * 1000;
const QUOTED_PRODUCTS_KEY = 'nft-quoted-products'
const ACCOUNT_LEADS_KEY = 'nft-account-leads'

export const itemHasLeads = (leads, itemId) => !!leads.find(item => item.id === itemId);
/**
 * Gets all leads from local storage and returns those created within 24 hours.
 * It also updates local storage to keep only recent leads.
 */
export const getRecentLeads = (localStorageKey = QUOTED_PRODUCTS_KEY) => {
  const allRecentLeadItems = JSON.parse(localStorage.getItem(localStorageKey)) || [];
  const recentLeads = allRecentLeadItems.filter(item => item.quoteTime + ONE_DAY_MS > new Date());
  localStorage.setItem(localStorageKey, JSON.stringify(recentLeads));
  return recentLeads;
}

/**
 * Adds a new lead to the list of leads (either product or account leads) and updates local storage accordingly.
 */
export const updateRecentLeads = (existingLeads, leadItemId, localStorageKey = QUOTED_PRODUCTS_KEY) => {
  const updatedLeads = [...existingLeads, { id: leadItemId, quoteTime: new Date().getTime() }];
  localStorage.setItem(localStorageKey, JSON.stringify(updatedLeads));
  return updatedLeads;
}

export const getRecentlyQuotedProducts = () => getRecentLeads(QUOTED_PRODUCTS_KEY)
export const getRecentAccountLeads = () => getRecentLeads(ACCOUNT_LEADS_KEY)

export const updateQuotedProducts = (quotedProducts, productId) => updateRecentLeads(quotedProducts, productId, QUOTED_PRODUCTS_KEY)
export const updateAccountLeads = (accountLeads, accountId) => updateRecentLeads(accountLeads, accountId, ACCOUNT_LEADS_KEY)

export const showTooltipAfterDownload = (item, fileLinks) => {
  if (!item) return;

  const relativeParent = item.closest('.js-files-container')
  const tooltip = relativeParent.querySelector('.bim-download-tooltip-container')

  fileLinks = document.querySelectorAll('.js-download-file');
  fileLinks.forEach(link => { link.closest('.js-download-file-item').style.paddingBottom = 'initial'; });

  const linkContainer = item.closest('.js-download-file-item');
  linkContainer.appendChild(tooltip)
  tooltip.classList.remove('afd-hide');
}
